module.exports = { update, updateContactPhone }

const tools = require('../../tools')

function update (state, { doc, effectiveDate, funders }) {
  return state.locationsDB.put(doc)
    .then(({ rev }) => {
      const updatedDoc = Object.assign({}, doc, { _rev: rev })
      return tools.docToEntity({ doc: updatedDoc, date: effectiveDate, funders })
    })
}

async function updateContactPhone (state, locationDoc, phoneNumber, program) {
  const normalizedPhone = String(phoneNumber).replace(/^\+/, '')

  const updatedDoc = {
    ...locationDoc,
    contacts: {
      ...locationDoc.contacts,
      [program]: {
        ...((locationDoc.contacts && locationDoc.contacts[program]) || {}),
        phone: normalizedPhone
      }
    },
    updatedAt: new Date().toJSON(),
    updatedBy: state.user.name
  }

  return state.locationsDB.put(updatedDoc)
}
